
import Vue from "vue";
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import { getProhibitedCategories } from "@/services/ProhibitedCategoriesService";

export default Vue.extend({
  name: "AddItemDetails",
  props: {
    cat: {
      type: String,
    },
    name: {
      type: String,
    },
    quant: {
      type: Number,
    },
    permit: {
      type: Boolean,
    },
    reason: {
      type: String,
    },
  },
  data() {
    return {
      descriptions: [] as Array<any>,
      description: "",
      quantity: 1 as number,
      itemName: "",
      prohibited: false,
      prohibitReason: ""
    };
  },
  watch: {
    itemName(value) {
      this.$emit("update:itemName", value);
    },
    quantity(value) {
      this.$emit("update:quantity", parseInt(value));
    },
    description(value) {
      this.$emit("update:description", value);
    },
    prohibitReason(value) {
      if (value) this.$emit("update:prohibitedReason", value);
    },
    prohibited(value: boolean) {
      if (!value) this.prohibitReason = "";
      this.$emit("update:permitted", !value);
    },
  },
  computed: {
    prohibitList() {
      return getProhibitedCategories();
    }
  },
  async beforeMount() {
    try {
      this.descriptions = await ApiService.Instance.getItemCategories();
      this.description = this.cat;
      this.quantity = this.quant;
      this.itemName = this.name;
      if (!this.permit) this.prohibited = this.permit;
      this.prohibitReason = this.reason;
    } catch (e) {
      error(e);
    }
  },
});
